const LB_ATC_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';

function lbSetBtnDefault(btn) {
  btn.disabled = false;
  btn.innerHTML = '<span>Add</span>' + LB_ATC_ICON;
}

document.addEventListener('DOMContentLoaded', () => {
  function initCarouselGradients() {
    const carouselCont = document.querySelector('.lb-carousel-cont');
    const carouselProducts = document.querySelector('.lb-carousel-products');
    if (!carouselCont || !carouselProducts || carouselCont.querySelector('.lb-gradient-right')) return;

    const leftGradient = document.createElement('div');
    leftGradient.className = 'lb-gradient-left';
    carouselCont.appendChild(leftGradient);

    const rightGradient = document.createElement('div');
    rightGradient.className = 'lb-gradient-right';
    carouselCont.appendChild(rightGradient);

    function updateGradients() {
      const { scrollLeft, scrollWidth, clientWidth } = carouselProducts;
      const hasOverflow = scrollWidth > clientWidth + 2;
      leftGradient.style.opacity = hasOverflow && scrollLeft > 2 ? '1' : '0';
      rightGradient.style.opacity = hasOverflow && scrollLeft + clientWidth < scrollWidth - 2 ? '1' : '0';
    }

    carouselProducts.addEventListener('scroll', updateGradients, { passive: true });

    const ro = new ResizeObserver(updateGradients);
    ro.observe(carouselProducts);
  }

  function initUpsellCard(card) {
    if (card.dataset.lbAtcInitialized) return;
    card.dataset.lbAtcInitialized = 'true';

    const checkbox = card.querySelector('card-checkbox');
    if (checkbox) checkbox.style.display = 'none';

    const ctaCont = card.querySelector('.lb-cta-cont');
    const ctaContHead = card.querySelector('.lb-cta-cont-head');
    const priceEl = card.querySelector('lb-price');
    const variantPicker = card.querySelector('lb-variant-picker');
    const qtyPicker = card.querySelector('lb-quantity-picker');
    const actionsContainer = card.querySelector('.lb-cta-actions');

    if (!ctaCont || !actionsContainer) return;

    const infoCol = document.createElement('div');
    infoCol.className = 'lb-info-col';

    if (ctaContHead) infoCol.appendChild(ctaContHead);

    if (variantPicker && variantPicker.querySelector('select')) {
      infoCol.appendChild(variantPicker);
    }
    if (qtyPicker) infoCol.appendChild(qtyPicker);
    if (priceEl) infoCol.appendChild(priceEl);

    ctaCont.insertBefore(infoCol, actionsContainer);

    const actionPickers = actionsContainer.querySelector('.lb-cta-action-pickers');
    if (actionPickers) actionPickers.remove();

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lb-atc-btn';
    lbSetBtnDefault(btn);
    actionsContainer.appendChild(btn);

    btn.addEventListener('click', async () => {
      if (btn.disabled) return;

      const select = card.querySelector('select.lb-variant-picker');
      const variantId = select ? select.value : card.getAttribute('lb-variant-id');

      const qtyInput = card.querySelector('input.lb-qty-count');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.disabled = true;
      btn.innerHTML = '<span>Adding\u2026</span>';

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);

        const minicart = document.querySelector('mini-cart');
        if (minicart) {
          formData.append(
            'sections',
            minicart.getSectionsToRender().map((s) => s.section),
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();

        if (data.status) {
          let errEl = card.querySelector('.lb-atc-error');
          if (!errEl) {
            errEl = document.createElement('div');
            errEl.className = 'lb-atc-error';
            const priceEl = card.querySelector('lb-price');
            if (priceEl) {
              priceEl.insertAdjacentElement('afterend', errEl);
            } else {
              card.querySelector('.lb-info-col')?.appendChild(errEl) ?? card.appendChild(errEl);
            }
          }
          errEl.textContent = data.description || 'Error';
          errEl.hidden = false;
          lbSetBtnDefault(btn);
          setTimeout(() => { errEl.hidden = true; }, 3000);
          return;
        }

        btn.innerHTML = '<span>Added!</span>';
        setTimeout(() => lbSetBtnDefault(btn), 1500);

        if (minicart) {
          minicart.renderContents(data);
          minicart.open(btn);
        }
      } catch {
        btn.innerHTML = '<span>Error</span>';
        setTimeout(() => lbSetBtnDefault(btn), 2000);
      }
    });
  }

  function processCards() {
    document.querySelectorAll('lb-upsell-flat-card.hydrated').forEach(initUpsellCard);
  }

  processCards();
  initCarouselGradients();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'LB-UPSELL-FLAT-CARD' && node.classList.contains('hydrated')) {
            initUpsellCard(node);
          }
          node.querySelectorAll?.('lb-upsell-flat-card.hydrated').forEach(initUpsellCard);
          if (node.querySelector?.('.lb-carousel-products') || node.classList.contains('lb-carousel-products')) {
            initCarouselGradients();
          }
        });
      } else if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const node = mutation.target;
        if (node.tagName === 'LB-UPSELL-FLAT-CARD' && node.classList.contains('hydrated')) {
          initUpsellCard(node);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
});
